export const getLastInteractiveTableConfigId = (state) => state.table.lastInteractiveConfigId
